module.exports = __webpack_public_path__ + "img/7.e4ee081e.jpg";